import { z } from 'zod';

export const partyFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'parties.form.errors.nameMin')
    .max(120, 'parties.form.errors.tooLong'),
});

export type PartyFormValues = z.infer<typeof partyFormSchema>;
